import Addon from './Addon';
import './addon.scss';

export default Addon;
